import { Route, Routes } from "react-router-dom";
import "./css/Toggleswitch.css";
import Survey from "./Survey";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" Component={Survey}></Route>
      </Routes>
    </>
  );
}
export default App;
